/* eslint-disable no-nested-ternary */
import React from 'react';
import CartProvider from '../Context/CartContext';
import CartData from './CartData';

const Cart = () => (
  <CartProvider>
    <CartData />
  </CartProvider>
);
export default Cart;
